module.exports = __webpack_public_path__ + "static/media/high_decisions.966daf05.png";